module.exports = __webpack_public_path__ + "img/3-2.0e4f2d6d.svg";